// extracted by mini-css-extract-plugin
export default {"imageContainer":"_fa-z","summaryPar":"aga-z","ratingCategories":"bga-z","reviewerInfo":"cga-z","reviewTypes":"dga-z","expanded":"ega-z"};